import "./App.css";

import { useEffect, useMemo, useState } from "react";

import { createQueryString } from "./Functions/queryFunctions";
import { ADMIN, USER } from "./constans/roles";
import { createPanelController } from "./controllers/panelController";
import Add from "./elements/Add/add";
import Creation, { CreationSchema } from "./elements/Creation/Creation";
import Edit from "./elements/Edit/Edit";
import { FilterPages } from "./elements/Filter/Filter";
import { Filters } from "./elements/Filters/Filters";
import Header from "./elements/Header/Header";
import Toast from "./elements/Toast/Toast";
import { useStateValue } from "./stateProvider/stateProvider";

function App({ server, roles }) {
  const [reducer, dispatch] = useStateValue();
  const [arr, setArr] = useState([]);
  const [clearForm, setClearForm] = useState(true);
  const [name, setName] = useState("");
  const [img, setImg] = useState("");
  const [clipIds, setClipIds] = useState([]);
  const [infoType, setInfoType] = useState("");
  const [info, setInfo] = useState("");

  const panelController = useMemo(
    () =>
      createPanelController({
        choosenTable: reducer.choosenTable,
        dispatch,
        setArr,
        setClearForm,
        setName,
        setImg,
        setInfoType,
        setInfo,
      }),
    [reducer.choosenTable, dispatch]
  );

  const canManageRecords = reducer.role === USER || reducer.role === ADMIN;
  const isLoading = !arr;
  const isEmptyWithFilters = Array.isArray(arr) && !arr.length;

  useEffect(() => {
    panelController.loadData();
    panelController.loadFiltersData();
    panelController.loadProfile();
  }, [panelController]);

  return (
    <div className="App">
      {infoType && (
        <Toast infoType={infoType} info={info} setInfoType={setInfoType} />
      )}

      <Header
        roles={roles}
        getData={panelController.loadData}
        server={server}
        name={name}
        img={img}
      />

      <Filters
        getAll={panelController.loadData}
        set={panelController.applyFilters}
        filtersActive={reducer.filtersActive}
      />

      <form>
        <div className="table-wrap ">
          <table className="creations  ">
            <thead>
              {reducer.filtersData && (
                <CreationSchema
                  filtersData={reducer.filtersData}
                  click={panelController.applyFilters}
                  getAll={panelController.loadData}
                  clear={clearForm}
                  setClear={setClearForm}
                  clips={clipIds}
                  setClips={setClipIds}
                ></CreationSchema>
              )}
            </thead>

            <tbody>
              {arr &&
                arr.map((item) => (
                  <Creation
                    clips={clipIds}
                    setClips={setClipIds}
                    clipId={item._id}
                    key={item._id}
                    item={item}
                    click={() => panelController.removeElement(item._id, item)}
                  ></Creation>
                ))}
            </tbody>
          </table>
        </div>
      </form>

      {reducer.filtersData && canManageRecords && (
        <Add
          getData={panelController.loadData}
          formaty={reducer.filtersData.Format}
          categories={reducer.filtersData.Kategoria}
          setInfoType={setInfoType}
          infoType={infoType}
          setInfo={setInfo}
          info={info}
        />
      )}
      {reducer.filtersData && canManageRecords && (
        <Edit
          getData={panelController.loadData}
          formaty={reducer.filtersData.Format}
          categories={reducer.filtersData.Kategoria}
          setInfoType={setInfoType}
          infoType={infoType}
          setInfo={setInfo}
          info={info}
        />
      )}

      <FilterPages
        query={createQueryString(reducer.paggingQuery)}
        click={panelController.changePage}
        docs={reducer.allPages}
        current={reducer.currentPage}
      />
      {isLoading && <h3 className="loading">Ladowanie...</h3>}
      {isEmptyWithFilters && (
        <h3 className="loading">Brak rekordow zgodnych z filtrami</h3>
      )}
    </div>
  );
}

export default App;
